import {Component, OnDestroy, OnInit} from '@angular/core';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {Api} from '@shared/constants/common-field.constants';
import {take, takeUntil} from 'rxjs/operators';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {PlatformCommand} from '@shared/commands/command-base';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {CommandService} from '@core/services/command.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {Subject} from 'rxjs';
import { RoleType } from '@features/spreadsheet/services/spreadsheet.constants';

class ScenarioCalculatorDynamicRolesModel {
  constructor(
    public id: string,
    public contributorRole: any,
    public reviewerRole: any
  ) {}
}

@Component({
    standalone: false,
    selector: 'app-txp-settings',
  templateUrl: './txp-settings.component.html',
  styleUrl: './txp-settings.component.scss'
})

export class TxpSettingsComponent implements OnInit, OnDestroy {
  data: any[] = [];
  selectedContributor = '';
  selectedReviewer = '';
  private destroy$ = new Subject<void>();
  private UserRole: { name: string; description: string; id: string; roleType: RoleType };

  constructor(private platformQueryService: PlatformQueryService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private commandService: CommandService,
              private snackBarService: SnackBarService) {
  }

  ngOnInit(): void {
    const query = new PlatformQuery();
    query.name = 'PermissionsRoleModelsQuery';
    query.api = Api.Security;

    this.platformQueryService.executeQuery(query).pipe(take(1)).subscribe(response => {
      const curData = response.fieldValues['PermissionsRoleModels'];
      this.data = curData.filter((o: any) => o.roleType === RoleType.DynamicRole);
    });

    const dynamicRolesQuery = new PlatformQuery();
    dynamicRolesQuery.name = 'ScenarioCalculatorDynamicRolesQuery';
    dynamicRolesQuery.api = Api.Spreadsheet;

    this.platformQueryService.executeQuery(dynamicRolesQuery).pipe(take(1)).subscribe(
      response => {
        const res = response.fieldValues['ScenarioCalculatorDynamicRoles'];
        if (res != null) {
          this.selectedContributor = res.contributorRole?.name;
          this.selectedReviewer = res.reviewerRole?.name;
        }
      }
    );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  saveTxpConfigurationSetting(): void {
    const command = new PlatformCommand('SaveScenarioCalculatorDynamicRolesCommand', Api.Spreadsheet);
    command.fieldValues['ScenarioCalculatorDynamicRoles'] = new ScenarioCalculatorDynamicRolesModel (
      '',
      this.GetInfo(this.selectedContributor),
      this.GetInfo(this.selectedReviewer)
    );

    this.fuseSplashScreenService.show();

    this.commandService.executePlatformCommand(command)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.fuseSplashScreenService.hide();
          this.snackBarService.showInformation('Settings saved!');
        },
        error: () => {
          this.fuseSplashScreenService.hide();
          this.snackBarService.showError('Failed to saved Settings!');
        }
      });
  }

  private GetInfo(name: string) {
    const contributorInfo = this.data.find(item => item.name === name);
    return this.UserRole = {
      description: contributorInfo.description,
      id: contributorInfo.Id,
      name: name,
      roleType: contributorInfo.roleType
    };
  }
}
